import { render } from "./portraits-study-record.vue?vue&type=template&id=d766ef84&scoped=true"
import script from "./portraits-study-record.vue?vue&type=script&lang=js"
export * from "./portraits-study-record.vue?vue&type=script&lang=js"

import "./portraits-study-record.vue?vue&type=style&index=0&id=d766ef84&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d766ef84"]])

export default __exports__